import Component from '../core/Component'
import $ from 'jquery'
import { loadComponents } from '../core/componentUtils'
import { disableScrolling, enableScrolling } from '../services/Viewport'

export default class StationDetail extends Component {
    constructor($element) {
        super($element)
        this.url = window.location.pathname
        this.$navLinks = this.$element.find('.detail__tab-panel')
    }

    prepare() {
        var self = this

        this.$navLinks.each(function () {
            if ($(this).attr('href') == self.url) {
                $(this).addClass('active')
            }
        })

        this.$navLinks.on('click', function (event) {
            event.preventDefault()
            self.url = $(this).attr('href')
            self.$element.addClass('is-loading')

            $.ajax({url: self.url, success: (result) => {
                var $buffer = $('<div></div>')
                $buffer.html(result)

                // update history
                window.history.replaceState({
                    "html": null,
                    "pageTitle": $buffer.find('title').text()
                }, "",  self.url)

                // open
                $('body .detail__container').html($buffer.find('.detail__container').html())
                loadComponents($('.detail__container'))

                // activate menu item
                self.$navLinks.removeClass('active')
                self.$navLinks.each(function () {
                    if ($(this).attr('href') == self.url) {
                        $(this).addClass('active')
                    }
                })
                self.$element.removeClass('is-loading')
            }})
        })

        this.$element.on('click', '[data-previous]', event => {
            event.preventDefault()
            this.$element.find('.detail__tab-panel.active').parent().prev().find('a').click()
        })

        this.$element.on('click', '[data-next]', event => {
            event.preventDefault()
            this.$element.find('.detail__tab-panel.active').parent().next().find('a').click()
        })
    }
}


// WEBPACK FOOTER //
// ./components/StationDetail.js